import React, { useState, useEffect, useLayoutEffect, useRef, useContext } from "react";
import { scrollIntoView } from "seamless-scroll-polyfill";

// context
import { DispatchContext, StateContext } from "bodycodi/cmap/app/components/common/context";

// components
import Comment from "./Comment";
import CommentDrawer from "./CommentDrawer";

// types
import { CommentListProps } from "./types";
import { getOS } from "bodycodi/cmap/app/js/common";

const CommentList = ({ list, refresh }: CommentListProps) => {
  const { state } = useContext(StateContext);
  const { dispatch } = useContext(DispatchContext);
  const [selectedComment, setSelectedComment] = useState<any>({});
  const commentsEndRef = useRef<HTMLDivElement>(null);

  const scrollToBottom = () => {
    scrollIntoView(commentsEndRef.current!, {
      behavior: "smooth",
    });
  };

  useEffect(() => {
    if (state.goToCommentSection && list.length > 0) {
      setTimeout(() => {
        scrollToBottom();
      }, 500);
    }
  }, [list]);

  useLayoutEffect(() => {
    return () => {
      dispatch({
        type: "POP_UP_OPEN",
        id: "COMUNITY_DTL_POP",
        open: { goToCommentSection: false },
      });
    };
  }, []);

  const renderCommentList = () => {
    return list.map((comment, index) => {
      return <Comment key={index} comment={comment} setSelectedComment={setSelectedComment} />;
    });
  };

  const renderEmpty = () => {
    return (
      <>
        아직 댓글이 없습니다.
        <br />
        회원님과 소통해보세요!
      </>
    );
  };

  return (
    <div
      className={
        "comunity-coment-list" +
        (list.length === 0 ? " empty" : "") +
        (getOS() === "IO" ? " padding" : "")
      }
    >
      {list.length === 0 && renderEmpty()}
      {list.length > 0 && renderCommentList()}
      <div ref={commentsEndRef} />

      <CommentDrawer selectedComment={selectedComment} refresh={refresh} />
    </div>
  );
};

export default CommentList;
